"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "IframeListener", {
    enumerable: true,
    get: function() {
        return IframeListener;
    }
});
require("iframe-resizer/js/iframeResizer.contentWindow");
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _IframePageInfoContext = require("./IframePageInfoContext");
const _VisibleAreaContext = require("./VisibleAreaContext");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const IframeListener = (param)=>{
    let { children } = param;
    var _window;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const [parentIFrame, setParentIFrame] = (0, _react.useState)((_window = window) === null || _window === void 0 ? void 0 : _window.parentIFrame);
    (0, _react.useEffect)(()=>{
        if (parentIFrame != null || typeof window === "undefined") {
            return ()=>undefined;
        }
        const listener = (e)=>{
            if (typeof e.data === "string" && e.data.startsWith("[iFrameSizer]")) {
                setParentIFrame(window.parentIFrame);
            }
        };
        window.addEventListener("message", listener);
        return ()=>{
            window.removeEventListener("message", listener);
        };
    }, [
        parentIFrame
    ]);
    return /*#__PURE__*/ _react.default.createElement(_IframePageInfoContext.IframeResizerProvider, {
        parentIFrame: parentIFrame
    }, /*#__PURE__*/ _react.default.createElement(_VisibleAreaContext.VisibleAreaProvider, null, children));
};

//# sourceMappingURL=IframeListener.js.map